export default {
  "report.list.head.title": "Event Reports | LINK-J",
  "report.list.head.title.suffix": " | Report | LINK-J",
  "report.list.head.description":
    "Explore detailed on LINK-J's events reports in the life sciences sector.",
  "report.list.title": "Event Reports",
  "report.list.category.main": "LINK-J Events/LINK-J Supported Events",
  "report.list.category.coSponsorship": "Co-sponsorship",
  "report.list.category.memberEvent": "Special Member Events",
  "report.list.category.attend": "Exhibitions",
  "report.list.category.all": "All Reports",
  // BBT
  "report.bbt.list.head.title": "",
  "report.bbt.list.head.description": "",
  "report.bbt.list.title": "",
  "report.bbt.list.category.all": "",
  // Detail
  "report.header": "Event Reports",
  "report.bbt.header": "Reports",
  "report.eventPdf.title": "イベントPDF",
} as const;
